import * as auth from './auth.service';
import * as session from './session.service';
import * as user from './user.service';
import * as member from './member.service';
import * as areaOfInterest from './areaOfInterest.service';
import * as channels from './channels.service';
import * as map from './map.service';
import * as enquiry from './enquiry.service';
import * as geometry from './geometry.service';
import * as organisationUser from './organisationUser.service';
import * as searchUsers from './searchUsers.service';
import * as reports from './reports.service';
import * as referral from './referral.service';
import * as common from './common.service';
import * as webhook from './webhook.service';
import * as clo from './clo.service';
import * as response from './response.service';
import * as websocket from './websocket.service';
import * as safetyMessageAndLogo from './safetyMessageAndLogo.service';
import * as track from './track.service';
import * as autodesk from './autodesk.service';
import * as reportsCrs from './reportsCrs.service';
import * as bydaMemberLookup from './bydaMemberLookup.service';
import * as bulkEnquiryLodgement from './bulkEnquiryLodgement.service';
import * as payment from './payment.service';

const Service = {
  auth,
  session,
  user,
  member,
  areaOfInterest,
  channels,
  map,
  enquiry,
  geometry,
  organisationUser,
  searchUsers,
  reports,
  referral,
  common,
  webhook,
  websocket,
  clo,
  response,
  safetyMessageAndLogo,
  autodesk,
  track,
  reportsCrs,
  bydaMemberLookup,
  bulkEnquiryLodgement,
  payment
};

export {
  auth,
  session,
  user,
  member,
  areaOfInterest,
  channels,
  map,
  enquiry,
  geometry,
  organisationUser,
  searchUsers,
  reports,
  referral,
  common,
  webhook,
  websocket,
  clo,
  response,
  safetyMessageAndLogo,
  autodesk,
  track,
  reportsCrs,
  bydaMemberLookup,
  bulkEnquiryLodgement,
  payment
};

export default Service;
